import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import moment from "moment";
import { UncontrolledTooltip } from "reactstrap";

class ProgramacaoLista extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.loadProgramacoes = this.loadProgramacoes.bind(this);
    this.notificar = this.notificar.bind(this);
    this.abrirPaginaProgramacao = this.abrirPaginaProgramacao.bind(this);
    this.abrirPaginaCopiaProgramacao =
      this.abrirPaginaCopiaProgramacao.bind(this);

    this.state = {
      programacoes: [],
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await this.loadProgramacoes();
  }

  async loadProgramacoes() {
    const idUsuario = localStorage.getItem("idUsuario");
    await axios
      .get(`${this.props.getBaseUrlApi()}/programacao/${idUsuario}`, this.props.parameters())
      .then((response) => {
        this.setState({ programacoes: response.data.programacoes });
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  abrirPaginaProgramacao(programacao) {
    localStorage.setItem(
      "dtini",
      moment(programacao.dtini).format("YYYY-MM-DD")
    );
    localStorage.setItem(
      "dtfim",
      moment(programacao.dtfim).format("YYYY-MM-DD")
    );
    localStorage.setItem("descProgramacao", programacao.desc);
    localStorage.setItem("actionPage", "editar");
    localStorage.setItem("idProgramacao", programacao._id);
    this.props.history.push("/programacao");
  }

  abrirPaginaCopiaProgramacao(idProgramacao) {
    localStorage.setItem("idProgramacaoCopiar", idProgramacao);
    this.props.history.push("/copiar-programacao");
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Lista de Programações" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"programacao"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Lista de Programações"
                  description="Acompanhamento das programações."
                /> */}
                <div className="row">
                  <div className="col-md-12 stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          {this.state.programacoes.length > 0 && (
                            <table
                              id="recent-purchases-listing"
                              className="table"
                            >
                              <thead>
                                <tr>
                                  <th>Descrição</th>
                                  <th>Data inicial</th>
                                  <th>Data final</th>
                                  <th>Situação</th>
                                  <th className="text-right">Ações</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.programacoes.map(
                                  (programacao, key) => (
                                    <tr key={key}>
                                      <td>{programacao.desc}</td>
                                      <td>
                                        {moment(programacao.dtini).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>
                                        {moment(programacao.dtfim).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        {programacao.situacao}
                                      </td>
                                      <td className="text-right">
                                        <i
                                          className="fa fa-search-plus font-000"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          id={`detalhar-programacao-${programacao._id}`}
                                          onClick={(e) =>
                                            this.abrirPaginaProgramacao(
                                              programacao
                                            )
                                          }
                                        ></i>

                                        <i
                                          className="fa fa-clone font-000"
                                          style={{
                                            cursor: "pointer",
                                            marginLeft: "8px",
                                          }}
                                          id={`detalhar-programacao-copiar${programacao._id}`}
                                          onClick={(e) =>
                                            this.abrirPaginaCopiaProgramacao(
                                              programacao._id
                                            )
                                          }
                                        ></i>
                                        <UncontrolledTooltip
                                          placement="right"
                                          target={`detalhar-programacao-${programacao._id}`}
                                        >
                                          Detalhar programação
                                        </UncontrolledTooltip>
                                        <UncontrolledTooltip
                                          placement="right"
                                          target={`detalhar-programacao-copiar${programacao._id}`}
                                        >
                                          Copiar programação
                                        </UncontrolledTooltip>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          )}
                          <span style={{ padding: "0 10px", fontSize: "13px" }}>
                            Para adicionar uma nova programação clique{" "}
                            <span
                              style={{
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                this.props.history.push(
                                  "/adicionar-programacao"
                                );
                              }}
                            >
                              aqui
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProgramacaoLista;
